import { getTimeseriesRawDataForDashboard } from "@src/cloud-connect/use-cases/get-timeseries-raw-data-for-dashboard";
import { buildRawDataGraphOptionObject } from "./build-raw-data-graph-option-object";
import { processNodeInformation } from "./process-node-information";

export const fetchTimeseriesRawDataAndBuildObjectForChart = async (
  groupId,
  tile,
  lookForLastAvailableTimeStampBeforeFetchingData,
  callback,
  setNodeInfoList,
  signal?: AbortSignal,
) => {
  const response = await getTimeseriesRawDataForDashboard(
    groupId,
    tile,
    lookForLastAvailableTimeStampBeforeFetchingData,
    signal,
  );

  processNodeInformation({
    response,
    tile,
    setState: setNodeInfoList,
  });

  callback(
    buildRawDataGraphOptionObject(tile.getTitle(), response, tile.getNodes()),
  );
};
